import { get, post } from './api';
import routes from './end-points';

export const adminSettingsApi = {
  initSettings: () => get(routes.adminSettings.initSettings),
  saveSetting: (setting) => post(routes.adminSettings.saveSetting, setting),
};
